import {Component, Input, OnInit, TemplateRef} from '@angular/core';

@Component({
    selector: 'app-container',
    templateUrl: './container.component.html',
    styleUrls: ['./container.component.scss'],
    standalone: false
})
export class ContainerComponent {

  @Input() body: TemplateRef<any>;
  @Input() isEnabled = true;
  @Input() overlayTooltip = "";
}
